/* ImageBlock — Sophisticated image card with upload placeholder */

interface ImageBlockProps {
  data: Record<string, string>
}

export default function ImageBlock({ data }: ImageBlockProps) {
  const src = data.src || ''
  const alt = data.alt || 'Image'
  const caption = data.caption || ''

  if (!src) {
    return (
      <div data-testid="card-image-block" className="group rounded-xl overflow-hidden border-2 border-dashed border-white/[0.06] hover:border-blue-500/20 transition-[border-color] duration-300 bg-white/[0.01]">
        <div className="flex flex-col items-center justify-center py-16 px-6">
          <div className="w-14 h-14 rounded-xl bg-white/[0.03] border border-white/[0.06] flex items-center justify-center mb-4 group-hover:border-blue-500/20 transition-colors">
            <svg className="w-6 h-6 text-white/15 group-hover:text-blue-500/30 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <p className="text-xs text-white/20 font-medium mb-1">Drop an image here</p>
          <p className="text-[10px] text-white/10">or click to upload</p>
        </div>
      </div>
    )
  }

  return (
    <div data-testid="card-image-block" className="group rounded-xl overflow-hidden bg-white/[0.02] border border-white/[0.06] hover:border-white/[0.12] transition-[border-color] duration-300">
      <div className="relative aspect-video overflow-hidden">
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
        />
        {/* Gradient overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      {caption && (
        <div className="px-4 py-2.5 border-t border-white/[0.04]">
          <p className="text-[11px] text-white/30 italic">{caption}</p>
        </div>
      )}
    </div>
  )
}
